export const BAR_SERIES = 'barSeries';
export const BAR_STEP_SERIES = 'barStepSeries';
export const CLUSTERED_COLUMN_SERIES = 'clusteredColumnSeries';
export const COLUMN_SERIES = 'columnSeries';
export const COLUMN_STEP_SERIES = 'columnStepSeries';
export const DIFFERENCE_BAR_SERIES = 'differenceBarSeries';
export const DIFFERENCE_COLUMN_SERIES = 'differenceColumnSeries';
export const DOT_SERIES = 'dotSeries';
export const LINE_SERIES = 'lineSeries';
export const STACKED_COLUMN_SERIES = 'stackedColumnSeries';
